import { useMemo } from 'react'

import routes from '~/routes'
import useAuth from '~/utils/auth/useAuth'

const useCustom = () => {
  const { isLoggedIn, userData, userRoleType } = useAuth()

  const defaultPath = useMemo(() => {
    if (!isLoggedIn || !userData) return

    const userPermissions: string[] = userData?.userAccess?.permissionMenu || []

    const defaultRoute = routes.find((f) => {
      const perm = f.permission
      if (!perm) return false
      if (Array.isArray(perm))
        return perm.some((p) => userPermissions.includes(p))
      return userPermissions.includes(perm)
    })

    return defaultRoute?.defaultPath ?? '/no-permission'
  }, [isLoggedIn, userData])

  const mustChangePwd = userData?.mustChangePwd ?? false

  return {
    data: {
      userData,
      userRoleType,
      defaultPath,
      mustChangePwd,
    },
  }
}

export default useCustom
